import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import { Checkbox, Toggle } from 'components/Controls';
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import ImageUpload from 'components/ImageUpload';

const WaiverForm:FC = () => {
  const { t } = useTranslation();

  const { control, watch } = useFormContext();

  const isWaiverEnabled = watch('waiver.enabled', false);

  return (
    <div className="w-full flex flex-wrap -mx-6 -y-4 px-6 pb-3">
      <div className="w-full landscape:w-1/2 tablet:w-full laptop:w-7/12 px-6">
        <div className="flex items-center mt-2 mb-4">
          <span className="block text-white text-base font-semibold mr-3">{t('pages.quizForm.enabledWaiverLabel')}</span>
          <Controller
            control={control} name="waiver.enabled"
            render={({ field: { onChange, value } }) => (
              <Toggle
                id="showWaiverBeforeQuiz"
                checked={value}
                onChange={onChange}
              />
            )}
          />
        </div>
        <MultiLanguageTextField
          name="waiver.text"
          helperText={t('pages.quizForm.waiverTextHint')}
          disabled={!isWaiverEnabled}
          multiline
          className="mb-4"
        />
        <Controller
          control={control} name="waiver.showBrandLogo"
          render={({ field: { onChange, value } }) => (
            <Checkbox
              label={t('pages.quizForm.showBrandLogoOnWaiverLabel')} id="showBrandLogoOnWaiver" name="showBrandLogoOnWaiver" checked={value}
              onChange={onChange}
              disabled={!isWaiverEnabled}
            />
          )}
        />
      </div>
      <div
        className="
          w-full landscape:w-1/2 tablet:w-full laptop:w-5/12
          landscape:border-l tablet:border-l-0 laptop:border-l
          px-6
        "
        style={{
          borderColor: 'rgba(255,255,255,0.2)'
        }}
      >
        <Controller
          control={control}
          name="waiver.image"
          render={({ field }) => (
            <ImageUpload
              {...field}
              format={MediaFormats.Logo}
              label="labels.image"
            />
          )}
        />
      </div>
    </div>
  )
}

export default WaiverForm;
